import React from 'react';
import { Line, Bar, Pie } from 'react-chartjs-2';

import { sendRequest } from './global.js';
import Storage from './Storage.js';

import SearchView from './SearchView.js';
import GraphListView from './GraphListView.js';
import GraphTableView from './GraphTableView.js';

var GraphsView = React.createClass({

  getDefaultState: function(props) {
    props = props || this.props;
    var state = {
      graphs: Storage.getConfig(props.configKey).graphs,
      config: Storage.getConfig(props.configKey).config,
      search: {},
      data: {},
    };
    // Default search interval
    if (state.config.search) {
      Object.keys(state.config.search).forEach(function(key){
        if (state.config.search[key].default) {
          state.search[key] = state.config.search[key].default;
        }
      });
    }
    return state;
  },

  getInitialState: function() {
    return this.getDefaultState();
  },

  componentWillReceiveProps: function(props) {
    if (props.configKey) {
      var state = this.getDefaultState(props);
      this.setState(state);
      this.requestInitialData(state);
    }
  },

  componentDidMount: function() {
    this.requestInitialData();
  },

  requestInitialData: function(state) {
    if (typeof state === "undefined") {
      state = this.state;
    }
    sendRequest({
      method: state.config.method,
      type: "GET",
      data: state.search,
      success: function(data) {
        this.setState({data: data});
      }.bind(this),
      error: function(xhr, status, err) {
      }
    });
  },

  onSearch: function(search) {
    var data = this.state.search;
    var keys = Object.keys(search);
    for (let i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (!search[key]) {
        data[key] = null;
        continue;
      }
      if (this.state.config.search[key].type === "text") {
        data[key] = search[key]; 
      }
      if (this.state.config.search[key].type === "select") {
        data[key] = search[key].id || search[key].value || null;
      }
      if (this.state.config.search[key].type === "multi") {
        data[key] = [];
        for (let j = 0; j < search[key].length; j++) {
          data[key].push(search[key][j].id); 
        }
      }
      if (this.state.config.search[key].type === "date-interval") {
        data[key] = {
          from: search[key].from,
          to: search[key].to,
        };
      }
      if (this.state.config.search[key].type === "address") {
        data[key] = search[key];
      }
    }

    this.requestInitialData();
  },

  render: function() {
    var thisView = this;

    // Search
    var searchView = null;
    if (typeof this.state.config.search !== "undefined") {
      searchView = 
      <SearchView
        config={this.state.config.search}
        onSearch={this.onSearch}
        defaultValue={this.state.search}
      />;
    }

    // Graphs
    var graphs = Object.keys(this.state.graphs).map(function(key){
      var graph = thisView.state.graphs[key];
      var graphData = thisView.state.data[key];

      var data = {
        labels: graphData ? (graphData.keys || []) : [],
        datasets: [],
        ids: graphData ? (graphData.ids || []) : [],
      };

      Object.keys(graph.options).forEach(function(optionKey){
        var graphOption = graph.options[optionKey];
        if (!graphData || !graphData[optionKey]) {
          return;
        }
        data.datasets.push({
          label: graphOption.title,
          data: graphData[optionKey],
          backgroundColor: graphOption.backgroundColor,
          borderColor: graphOption.borderColor,
          // line
          pointRadius: 1,
          pointBorderWidth: 1,
          pointHoverRadius: 7,
          pointHitRadius: 7,
          // custom
          columns: graphOption.columns,
        });
      });

      var options = {
        title: {
          display: true,
          text: graph.title,
        },
      }
      if (graph.type !== "pie") {
        options.scales = { yAxes: [ { ticks: { beginAtZero:true } } ] }
      }

      var width = 1000;
      var height = graph.size === "half" ? 1000 : 475;

      var chart = null;
      if (graph.type === "bar") {
        chart = <Bar data={data} options={options} width={width} height={height} />
      }
      if (graph.type === "pie") {
        chart = <Pie data={data} options={options} width={width} height={height} />
      }
      if (graph.type === "line") {
        chart = <Line data={data} options={options} width={width} height={height} />
      }
      if (graph.type === "list") {
        chart = <GraphListView data={data} options={options} objectPageKey={graph.objectPageKey}/>
      }
      if (graph.type === "table") {
        chart = <GraphTableView data={data} options={options} objectPageKey={graph.objectPageKey}/>
      }

      return (
        <div
          key={key} 
          data-key={key}
          className={"graph " + graph.size + " type-" + graph.type}
        >{chart}</div>
      )

    });
    return (
      <div className="adminContent customScrollBar">
        <h1 className="page-header">
          {this.state.config.title}
        </h1>
        {searchView}
        {graphs}
      </div>
    )
  },
});

export default GraphsView;



// WEBPACK FOOTER //
// ./src/GraphsView.js